import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1420. 受注案件管理会計削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_accountings/:sales_order_accounting_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  sales_order_accounting_id: number;
};
const destroySalesOrderAccounting = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_accountings/${props.sales_order_accounting_id}`
  );
};
export const useDestroySalesOrderAccounting = () => {
  return useMutation({
    mutationFn: destroySalesOrderAccounting
  });
};